import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e83ba73"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app" }

import zhCN from 'ant-design-vue/es/locale/zh_CN'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import { onMounted } from 'vue'
// 注册全局的滚动条事件

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

dayjs.locale('zh-cn')
onMounted(() => {
  document.body.addEventListener(
    'scroll',
    (e: { target: any }) => {
      const dom = e.target
      let className = dom.className
      if (!className.includes('active-scrolling-dom')) {
        dom.className += ' active-scrolling-dom'
      }
      if (!dom.onscrollend) {
        dom.onscrollend = (e: any) => {
          let className = dom.className
          if (className.includes('active-scrolling-dom')) {
            let classNameWithoutCls = className.split('active-scrolling-dom')
            dom.className = classNameWithoutCls.join(' ')
          }
        }
      }
    },
    { capture: true }
  )
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, { locale: _unref(zhCN) }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_router_view)
      ])
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})